<template>
    <div id="project-show">
        <div class="container">
            <b-breadcrumb :items="breadcrumb" v-if="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="col-lg-3">
                    <div class="rules-nav mb-32">
                        <nav>
                            <ul>
                                <li>
                                    <router-link class="h4 color-text-white active-rules" to="/projects">Снято на технику MRental</router-link>
                                </li>
<!--                                <li>-->
<!--                                    <router-link class="h4 color-text-white" to="/projects/tv">MRental TV</router-link>-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <router-link class="h4 color-text-white" to="/projects/support">Поддержка проектов</router-link>-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <router-link class="h4 color-text-white" to="/projects/application">Оставить заявку</router-link>-->
<!--                                </li>-->

                            </ul>
                        </nav>
                    </div>

                    <div class="d-none d-xl-block">
                        <catalog-categories></catalog-categories>
                    </div>

                </div>

                <div class="col-lg-9">
                    <div v-if="project">
                        <h1 class="as-h2 mb-40">{{project.title}}</h1>
                        <div class="box-shadow mb-40">
                            <div class="mb-24" v-if="project.big_image">
                                <img :src="'/storage/' + project.big_image" alt="" class="img-fluid">
                            </div>
                            <div v-html="project.long_desc"></div>
                        </div>

                        <div v-if="projectsLatest && projectsLatest.length > 0">
                            <span class="title-2 mb-28">Вас также может заинтересовать:</span>
                            <div class="grid-container" v-if="projectsLatest">
                                <div class="box-grid"  v-for="(item, i) in projectsLatest"
                                     :key="i">
                                    <router-link :to="'/projects/' + item.slug">
                                        <img :src="'/storage/' + item.image" :alt="item.title">
                                        <span class="title-4 color-text-white">{{item.title}}</span>
                                    </router-link>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div v-if="loading" class="loading-box">
                        <b-spinner></b-spinner>
                    </div>

                    <div class="mt-5" v-if="seo_text">
                        <p v-html="seo_text"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                loading: true,

                project: null,
                projectsLatest: null,


                breadcrumb: null,
                seo_text: null
            }
        },

        watch: {
            $route() {
                this.loading = true;
                this.init();
            },
        },

        mounted() {
            this.init()
        },

        methods: {
            init() {
                this.project = null;
                this.projectsLatest = null;


                let url = '/api/projects/show';
                let slug = this.$route.params.slug;
                axios.post(url, {'slug': slug})
                    .then(response => {
                        this.project = response.data.project;
                        this.projectsLatest = response.data.projectsLatest;
                        this.getBreadcrumb();
                        this.loading = false;

                        this.seo_text = this.project.seo_text;

                        document.title = this.project.seo_title ? this.project.seo_title : this.project.title + ' - проекты Фотопроката MRental';
                        let desc = this.project.seo_desc ? this.project.seo_desc : this.project.title + '. На оборудовании Фотопроката MRental реализованы лучшие проекты в сфере рекламы, фильмов и клипов белорусского и зарубежного рынков.';
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);

                    })
            },

            getBreadcrumb() {
                this.breadcrumb = [
                    {
                        text: 'Главная',
                        to: { name: 'pages-index' }
                    },
                    {
                        text: 'Проекты',
                        to: { name: 'pages-projects' }
                    },
                    {
                        text: this.project.title,
                        active: true
                    }
                ]

            }
        }
    }
</script>

